var _circle, _path, _rect, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#222228"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43 49H81.1588C84.7834 49 87.5804 52.1891 87.1075 55.7827L83.3432 84.3914C83.1468 85.8841 81.8745 87 80.3689 87H43V49Z",
    fill: "#4A67FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 33,
    width: 41,
    height: 53,
    rx: 4,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 39H66",
    stroke: "#73737B",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46H58",
    stroke: "#73737B",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6595 44C32.7663 44 31.3464 45.732 31.7177 47.5883L32.0001 49H31.9999L37.6899 82.0189C38.1859 84.8971 40.6822 87 43.6028 87H80.6258C81.8661 87 82.8074 85.8827 82.5967 84.6604L77.3099 53.9811C76.8139 51.1029 74.3176 49 71.397 49H48.0001L47.6432 47.2155C47.2692 45.3458 45.6276 44 43.7208 44H34.6595Z",
    fill: "#4A67FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4784 81.3922C41.2309 80.1546 42.1775 79 43.4396 79H51.3604C52.3138 79 53.1346 79.6729 53.3216 80.6078L53.5216 81.6078C53.7691 82.8454 52.8225 84 51.5604 84H43.6396C42.6862 84 41.8654 83.3271 41.6784 82.3922L41.4784 81.3922Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon2);
export default __webpack_public_path__ + "static/media/money-icon-2.ef37918acec050a7140e7ab650667ca1.svg";
export { ForwardRef as ReactComponent };